/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineTopFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterPrice_user" | "SbRespRefineMenuFilterDimensions_user">;
    readonly " $refType": "SbRespRefineTopFilters_user";
};
export type SbRespRefineTopFilters_user$data = SbRespRefineTopFilters_user;
export type SbRespRefineTopFilters_user$key = {
    readonly " $data"?: SbRespRefineTopFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineTopFilters_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineTopFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuFilterDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '54c57eb65891d4a7e818b019ae6c277b';
export default node;
